/* eslint-disable no-useless-escape */
export function validatePhoneNumber(phoneNumber) {
    const pattern =
        /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

    return pattern.test(phoneNumber);
}
